import logoVertical_default from "../../assets/Images/logoVertical.png.js";
/* empty css          */
import "react";
import { jsx, jsxs } from "react/jsx-runtime";
// src/components/FullScreenLoading/index.tsx
var FullScreenLoading = ({ statusMsg }) => /* @__PURE__ */ jsxs("div", {
	className: "app-wrapper-fullscreen-loading flex flex-col justify-center align-middle",
	children: [/* @__PURE__ */ jsx("div", {
		className: "flex justify-center",
		children: /* @__PURE__ */ jsx("img", {
			alt: "THERMS logo",
			src: logoVertical_default
		})
	}), statusMsg && /* @__PURE__ */ jsx("div", {
		className: "mt-xl text-center text-lg",
		children: /* @__PURE__ */ jsx("em", {
			className: "opacity-10",
			children: statusMsg
		})
	})]
});
export { FullScreenLoading };

//# sourceMappingURL=index.js.map